import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { getCourse } from '../../actions/courses';
import { getCurrentUser } from '../../actions/user';
import { getToolIds } from '../../util/tool';
import { PRODUCT_MODELS } from '../../util/constants';
import { getConfigObject } from '../../util/config';
import {
  getPathfinderUrl,
  isQQInsightsSupported,
  isSectionCourseType,
} from '../../util/util';
import { REPORT_TYPES, COURSE_TABS } from '../../actions/constants';
import {
  refreshReport as refreshReportAction,
  getCourseAbstract,
  sendAnalyticsEvent,
} from '../../actions/reports';
import { viewWidget } from '../../analyticsEvents';
import DefaultOverviewWidget from './OverviewWidgetComponents/DefaultOverviewWidget';
import ReadAndPracticeOverviewWidget from './OverviewWidgetComponents/ReadAndPracticeOverviewWidget';
import QQOverviewWidget from './OverviewWidgetComponents/QQOverviewWidget';
import SkillsOverviewWidget from './OverviewWidgetComponents/SkillsOverviewWidget';
import PathFinderDiagnosticsWidget from './OverviewWidgetComponents/PathFinderDiagnosticsWidget';
import RPWidgetsContainer from './RPWidgetsContainer';
import QQWidgetsContainer from './QQWidgetsContainer';
import SkillsWidgetContainer from './SkillsWidgetContainer';
import StudentWidget from './studentWidget';
import s from './overviewWidget.module.css';

const checkForActiveUnit = (data) => (data && !!data.activeUnit) || false;

export const ReadAndPracticeWidgets = (props) => {
  const { course, courseId, onTabChange } = props;
  const redirectButtons = {
    performance: COURSE_TABS.MYCOURSE.id,
    diagnostics: false,
  };

  const {
    pathfinder: pathfinderToolId,
    pathfinder2: pathfinder2ToolId,
  } = getToolIds();

  const assignments = course.data.assignments || [];
  const hasPathfinder = assignments.find(
    (a) => a.tool === pathfinderToolId || a.tool === pathfinder2ToolId
  );

  if (hasPathfinder) {
    redirectButtons.diagnostics = getPathfinderUrl(courseId);
  }
  return (
    <React.Fragment>
      <ReadAndPracticeOverviewWidget
        redirectTo={redirectButtons}
        btnText="View performance"
        onTabChange={onTabChange}
      />
      {redirectButtons.diagnostics && (
        <PathFinderDiagnosticsWidget redirectTo={redirectButtons} />
      )}
    </React.Fragment>
  );
};
ReadAndPracticeWidgets.propTypes = {
  course: PropTypes.object,
  courseId: PropTypes.string,
  onTabChange: PropTypes.func,
};

export const QQAndSkillsWidgets = (props) => {
  const {
    DASHBOARDS_ENABLED_QQ,
    DASHBOARDS_ENABLED_SKILLS,
    DASHBOARDS_ENABLED_SKILLS_REFLECTION_SUMMARY,
    DASHBOARD_ENABLED_INSIGHTS_SNAPSHOT_WIDGET,
    DASHBOARDS_ENABLED_110,
  } = getConfigObject();

  const { reports, course, onTabChange, loading, error, getLaunchUrl } = props;
  const { courseAbstract } = reports || {};
  const assignments = course.data.assignments || [];

  const { productModelId, courseId, courseShortId, enrollments } =
    courseAbstract || {};
  const overviewWidget = reports.overviewWidget || reports.skillsWidget;
  const comingSoon = reports.comingSoon;
  const authorized = reports.authorized;

  const supportsQQInsights = isQQInsightsSupported(productModelId);
  const reportType =
    productModelId === PRODUCT_MODELS.skills
      ? REPORT_TYPES.skills
      : REPORT_TYPES.subunit;
  let redirectTo = null;
  const redirectButtons = {
    performance:
      DASHBOARDS_ENABLED_SKILLS_REFLECTION_SUMMARY &&
      productModelId === PRODUCT_MODELS.skills
        ? 'reports'
        : `reports/type/${reportType}`,
  };
  if (
    overviewWidget &&
    (overviewWidget.hasPathfinderActivity || overviewWidget.pathfinderUnit)
  ) {
    redirectButtons.diagnostics = getPathfinderUrl(courseId);
  }
  if ((DASHBOARDS_ENABLED_110 || comingSoon) && supportsQQInsights) {
    redirectButtons.performance = 'reports';
  }

  const {
    learningcurve: learningcurveToolId,
    assessment: assessmentToolId,
  } = getToolIds();

  const shouldDisplaySkillsOverviewWidget = () =>
    productModelId === PRODUCT_MODELS.skills &&
    (DASHBOARD_ENABLED_INSIGHTS_SNAPSHOT_WIDGET ||
      (!DASHBOARD_ENABLED_INSIGHTS_SNAPSHOT_WIDGET &&
        overviewWidget &&
        overviewWidget.hasWritingActivity)) &&
    DASHBOARDS_ENABLED_SKILLS;
  const shouldDisplayQQDiagnosisCard = () =>
    DASHBOARDS_ENABLED_QQ &&
    supportsQQInsights &&
    DASHBOARD_ENABLED_INSIGHTS_SNAPSHOT_WIDGET &&
    !checkForActiveUnit(overviewWidget) &&
    overviewWidget &&
    overviewWidget.pathfinderUnit;
  const shouldDisplayQQOverviewWidget = () =>
    DASHBOARDS_ENABLED_QQ &&
    supportsQQInsights &&
    ((DASHBOARD_ENABLED_INSIGHTS_SNAPSHOT_WIDGET &&
      ((checkForActiveUnit(overviewWidget) && overviewWidget.hasStudents) ||
        loading)) ||
      (!DASHBOARD_ENABLED_INSIGHTS_SNAPSHOT_WIDGET &&
        assignments.has(
          (assignment) =>
            assignment.tool === learningcurveToolId ||
            assignment.tool === assessmentToolId
        )));

  const displayWidget = () => {
    if ((!loading && !authorized) || error) {
      return false;
    }

    let shouldDisplayWidget = false;
    if (shouldDisplaySkillsOverviewWidget()) {
      redirectTo = redirectButtons;
      shouldDisplayWidget = true;
    }
    if (shouldDisplayQQOverviewWidget()) {
      redirectTo = redirectButtons;
      shouldDisplayWidget = true;
    }
    if (shouldDisplayQQDiagnosisCard()) {
      redirectTo = redirectButtons;
      shouldDisplayWidget = true;
    }
    return shouldDisplayWidget;
  };

  if (!displayWidget()) {
    return null;
  }

  let btnText = 'View Unit Performance';
  let widgetTitle = 'Students Insights';
  let widgetDescription =
    'A snapshot of student performance in the most recent unit.';
  if (productModelId === PRODUCT_MODELS.skills) {
    btnText = 'View Details';
    widgetTitle = 'Course Performance Overview';
    widgetDescription =
      'An easy snapshot of overall performance and class trends over time.';
  }
  const defaultWidget = (
    <DefaultOverviewWidget
      redirectTo={redirectTo}
      btnText={btnText}
      widgetTitle={widgetTitle}
      widgetDescription={widgetDescription}
      onTabChange={onTabChange}
    />
  );

  const qqWidget = () => {
    const hasActiveUnit = checkForActiveUnit(overviewWidget);
    const showPathfinder =
      overviewWidget &&
      overviewWidget.pathfinderUnit &&
      overviewWidget.hasStudents &&
      redirectButtons.diagnostics;
    if (!loading && !hasActiveUnit && !showPathfinder) {
      return null;
    }

    return (
      <React.Fragment>
        {(hasActiveUnit || loading) && (
          <QQOverviewWidget
            onTabChange={onTabChange}
            loading={loading}
            data={overviewWidget}
            shortId={courseShortId}
            getLaunchUrl={getLaunchUrl}
          />
        )}
        {showPathfinder && (
          <PathFinderDiagnosticsWidget redirectTo={redirectButtons} />
        )}
      </React.Fragment>
    );
  };

  const skillsWidget = (
    <SkillsOverviewWidget
      onTabChange={onTabChange}
      loading={loading}
      data={overviewWidget}
      shortId={courseShortId}
      getLaunchUrl={getLaunchUrl}
    />
  );

  if (
    getConfigObject().DASHBOARD_ENABLED_INSIGHTS_SNAPSHOT_WIDGET &&
    !comingSoon
  ) {
    const overviewWidgets = {};
    overviewWidgets[PRODUCT_MODELS.skills] =
      enrollments === 0 ? null : skillsWidget;
    overviewWidgets[PRODUCT_MODELS.quantitative] = qqWidget();
    overviewWidgets[PRODUCT_MODELS.qualitative] = qqWidget();
    overviewWidgets[PRODUCT_MODELS.goreact] = qqWidget();
    overviewWidgets[PRODUCT_MODELS.essentials] = qqWidget();
    return (
      <div className={s.overviewWidget}>
        {overviewWidgets[productModelId] || defaultWidget}
      </div>
    );
  }
  return <div className={s.overviewWidget}>{defaultWidget}</div>;
};
QQAndSkillsWidgets.propTypes = {
  course: PropTypes.object,
  reports: PropTypes.object,
  onTabChange: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.object,
};

export class OverviewWidget extends Component {
  static propTypes = {
    course: PropTypes.object,
    onTabChange: PropTypes.func,
    refreshReport: PropTypes.func,
    getCourse: PropTypes.func,
    getCourseAbstract: PropTypes.func,
    getCurrentUser: PropTypes.func,
    getLaunchUrl: PropTypes.func,
    launchActivity: PropTypes.func,
    sendAnalyticsEvent: PropTypes.func,
    reports: PropTypes.object,
    loading: PropTypes.bool,
    error: PropTypes.any,
  };

  async componentDidMount() {
    const { courseId } = this.props;

    await Promise.all([
      this.props.getCourse(courseId),
      this.props.getCourseAbstract(courseId),
      this.props.getCurrentUser(courseId),
    ]);
  }

  componentWillReceiveProps(newProps) {
    const newProductModelId = _.get(
      newProps,
      'reports.courseAbstract.productModelId'
    );
    if (
      newProductModelId &&
      newProductModelId !==
        _.get(this.props, 'reports.courseAbstract.productModelId')
    ) {
      this.sendAnalytics(
        newProductModelId,
        _.get(newProps, 'reports.courseAbstract.student')
      );
    }
  }

  sendAnalytics(productModelId, student) {
    let newReportType;
    switch (productModelId) {
      case PRODUCT_MODELS.skills:
        newReportType = student
          ? REPORT_TYPES.revisionPlanWidget
          : REPORT_TYPES.skillsWidget;
        break;
      case PRODUCT_MODELS.quantitative:
      case PRODUCT_MODELS.qualitative:
      case PRODUCT_MODELS.goreact:
      case PRODUCT_MODELS.essentials:
        newReportType = REPORT_TYPES.qqWidget;
        break;
      default:
        break;
    }
    if (newReportType) {
      this.props.sendAnalyticsEvent(viewWidget(newReportType));
    }
  }

  shouldDisplayStudentActivity = () => {
    const { courseAbstract } = this.props.reports || {};
    const { enrollments } = courseAbstract || {};
    return enrollments > 0;
  };

  render() {
    const {
      course,
      reports,
      loading,
      error,
      onTabChange,
      getLaunchUrl,
    } = this.props;

    const { courseAbstract } = reports || {};

    if (!courseAbstract) {
      return null;
    }

    const {
      id: courseId,
      productModelId,
      student: isStudent = true,
    } = courseAbstract;
    if (isStudent) {
      return <StudentWidget getLaunchUrl={getLaunchUrl} />;
    }

    const isSectionManager = isSectionCourseType(
      _.get(course, 'data.course_type'),
      true
    );

    switch (productModelId) {
      case PRODUCT_MODELS.readandpractice:
        return (
          <RPWidgetsContainer
            course={course}
            onTabChange={onTabChange}
            reports={reports}
            courseId={courseId}
            isSectionManager={isSectionManager}
            getLaunchUrl={getLaunchUrl}
          />
        );
      case PRODUCT_MODELS.qualitative:
      case PRODUCT_MODELS.quantitative:
      case PRODUCT_MODELS.goreact:
      case PRODUCT_MODELS.essentials:
        return (
          <QQWidgetsContainer
            course={course}
            onTabChange={onTabChange}
            reports={reports}
            loading={loading}
            error={error}
            isSectionManager={isSectionManager}
            getLaunchUrl={getLaunchUrl}
            shouldDisplayStudentActivity={this.shouldDisplayStudentActivity()}
          />
        );
      case PRODUCT_MODELS.skills:
        return (
          <SkillsWidgetContainer
            course={course}
            onTabChange={onTabChange}
            reports={reports}
            loading={loading}
            error={error}
            isSectionManager={isSectionManager}
            shouldDisplayStudentActivity={this.shouldDisplayStudentActivity()}
            getLaunchUrl={getLaunchUrl}
          />
        );
      default:
        return null;
    }
  }
}

const isLoading = (state) =>
  !state.reports.courseAbstract ||
  state.reports.courseAbstract.loading ||
  !state.reports.overviewWidget ||
  state.reports.overviewWidget.loading;

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      refreshReport: refreshReportAction,
      getCourse,
      getCourseAbstract,
      getCurrentUser,
      sendAnalyticsEvent,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  course: state.courses.course,
  reports: state.reports,
  loading: isLoading(state),
  error:
    (state.reports.courseAbstract && state.reports.courseAbstract.error) ||
    (state.reports.overviewWidget && state.reports.overviewWidget.error),
});

export default connect(mapStateToProps, mapDispatchToProps)(OverviewWidget);
